module.exports = __webpack_public_path__ + "img/contentBox1_info_img1.9dcf871f.png";